module.exports = __webpack_public_path__ + "img/apply_b.064e7590.png";